export enum SsoProvider {
    Google = 'Google',
    Apple = 'Apple',
    Microsoft = 'Microsoft'
}
